import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";

@Component({
  selector: "app-expired-validation",
  templateUrl: "./expired-validation.component.html",
  styleUrls: ["./expired-validation.component.scss"],
})
export class ExpiredValidationComponent {
  constructor(
    private dialogRef: MatDialogRef<ExpiredValidationComponent>,
    private router: Router
  ) {}

  /**
   * Closes the dialog and navigate to landing
   */
  public close(): void {
    this.dialogRef.close(true);
    this.router.navigate(["/landing"]);
  }
}
